export const VERIFICATION_STATUS_PENDING = 'PENDING';
export const VERIFICATION_STATUS_APPROVED = 'APPROVED';